module.exports = __webpack_public_path__ + "static/media/hajj-and-umrah-slider.d7a15489.jpg";